import { Homepage } from './Homepage';

export default Homepage;
